import { SEPARATOR, exactValidator, genericValidateName, uuidValidator } from './genericName';
import * as libHabitat from './habitat';
export const prefix = 'investors';
export const prefixWithSeparator = prefix + SEPARATOR;
export const IDToName = ({ habitatID, investorID }) => {
    return libHabitat.IDToName({ habitatID }) + SEPARATOR + prefixWithSeparator + investorID;
};
export const validateName = genericValidateName([
    exactValidator(libHabitat.prefix),
    uuidValidator(),
    exactValidator(prefix),
    uuidValidator(),
]);
export const nameToID = (name) => {
    validateName(name); // throws if invalid
    const parts = name.split('/');
    return {
        habitatID: parts[1],
        investorID: parts[3],
    };
};
